export interface TeamData {
  id: number;
  img: string;
  name: string;
  prof: string;
  desc: string | null;
  twitter: string;
}

const data: Record<string, TeamData[]> = {
  "Team": [
    {
      id: 1,
      img: require('images/team/item-1.png'),
      name: "Michelle Janice",
      prof: "Founder - CEO",
      desc: "Senior Art Director with over 10+ years of experience who has spearheaded fortune 500 projects valued at over $200 million. Has worked with some of the largest gaming, betting and entertainment giants helping them strategically position products for optimization. Has 100% success rate in increasing user base and utility of platforms.",
      twitter: "#"
    },
    {
      id: 2,
      img: require('images/team/item-2.png'),
      name: "Rouchelle Irani",
      prof: "Co-Founder - CMO",
      desc: "Senior Business Developer and Partnerships Manager at BBDO with over 7 years experience managing a $100 million portfolio. Crypto enthusiast with thorough understanding of the industry's requirements, strategies, and goals, Rouchelle is skilled at maintaining operations, outreach, and partnerships.",
      twitter: "#"
    },
    {
      id: 3,
      img: require('images/team/item-3.png'),
      name: "Shermen Joseph",
      prof: "CTO",
      desc: "With over 9 years experience in blockchain solution development, and deployment, have implemented solutions handling over $1 million in total transacted value. Expert in JavaScript, Solidity, BSC, Rust, Nodejs, Reactjs, and Angular Web3, Shermen has worked for the likes LGS and Tech Data, now heading up blockchain development at GETSETPLAY.",
      twitter: "#"
    },
    {
      id: 4,
      img: require('images/team/item-4.png'),
      name: "Cassal Leon",
      prof: "Creative Lead",
      desc: "Ui/ux lead with over 10+ years of experience in website and mobile design who focused on user flow, creation of wireframes, and creating clickable prototypes at blockfi.He is especially skilled in designing and developing ui mockups, prototypes and illustrations.",
      twitter: "#"
    },
    {
      id: 5,
      img: require('images/team/item-5.png'),
      name: "Erwin Thomas",
      prof: "Parnership Strategist",
      desc: "A talented expert global deals leader with over 5+ years of experience in Digital Marketing deals, IT deals, and Business Reputation Manager with absolute client care comprehension. Profound project management & strategic partnership qualities. He is now heading Partnerships at GetSetPlay.",
      twitter: "#"
    }
  ],
  "Advisors": [
    {
      id: 6,
      img: require('images/team/item-6.png'),
      name: "Stephanie Nijssen",
      prof: "Expisiensed Blockchain Gaming Advisor",
      desc: null,
      twitter: "#"
    },
    {
      id: 7,
      img: require('images/team/item-7.png'),
      name: "Lee Kai",
      prof: "Strategic Avisor",
      desc: null,
      twitter: "#"
    },
    {
      id: 8,
      img: require('images/team/item-8.png'),
      name: "Crypto Executives",
      prof: "Investment Advisory Firm",
      desc: null,
      twitter: "#"
    }
  ]
};
export default data;